export type GetSitrepsResponse = {
  id: UUID;
  item_id: UUID;
  status: string;
  sitrep_source: string;
  sitrep_source_id: UUID;
  sitrep_template_id: UUID;
  name: string;
  timestamp: string;
  user_guid: UUID;
  group_guid: UUID;
  error_message?: string;
  archived: boolean;
  aor_id: UUID | null;
  description: string | null;
  incident_id: UUID | null;
  is_sitrep: boolean;
  // Update tracking metadata
  updated_at: string | null;
  updated_by_user_guid: UUID | null;
  created_by_user_name: string | null;
  updated_by_user_name: string | null;
  // Approval tracking metadata
  approvals: {
    approved_by_user_guid: UUID;
    approved_by_user_name: string | null;
    approved_at: string | null;
  }[];
  approval_status?: 'DRAFT' | 'PENDING' | 'APPROVED';
  pending_reviewer_names?: string | null;
};

export type SitrepViewDataProps = {
  data: GetSitrepsResponse[];
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
};

export enum SitrepViewTabs {
  CurrentSitrep = 'CurrentSITREP',
  Historical = 'Historical',
  Drafts = 'Drafts',
  Reviews = 'PendingReviews',
}

/**
 * Explicit card surface — determines which capabilities and controls are
 * available on a SITREP card.
 *
 * - **Current** — read-only content + "Draft New Version" button.
 * - **Historical** — read-only content, no draft button.
 * - **Draft** — full editing (add/remove/reorder sections, AI generate,
 *   section settings, file attachments, request approval).
 * - **Review** — approve / reject as primary workflow. Editing is available
 *   intentionally via an explicit "Edit before approving" toggle so that
 *   reviewers can make changes before approval when needed — but the editing
 *   path is deliberately separated from the draft-authoring controls.
 */
export enum SitrepCardSurface {
  Current = 'Current',
  Historical = 'Historical',
  Draft = 'Draft',
  Review = 'Review',
}

export type EditableReportsSitrepCardProps = {
  sitrep: GetSitrepsResponse;
  surface: SitrepCardSurface;
};
